import type { ComponentPropsWithRef } from 'react'

import { cn } from '@/shared/lib'

type CountBadgeProps = ComponentPropsWithRef<'span'> & {
  tone?: 'neutral' | 'danger'
}

/**
 * The small pill that sits on a nav item or a tab. `danger` is the unread /
 * needs-attention count and is the only one that gets a solid fill.
 */
export function CountBadge({
  className,
  tone = 'neutral',
  children,
  ...props
}: CountBadgeProps) {
  return (
    <span
      data-slot="count-badge"
      className={cn(
        'inline-flex items-center justify-center rounded-full px-1.25 tabular-nums',
        tone === 'danger'
          ? 'size-5 min-w-5 bg-destructive text-label font-bold text-destructive-foreground'
          : 'size-4.5 min-w-4.5 bg-secondary text-label text-fg-secondary',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  )
}
